export const browserStatusEndpoint = "/api/status";
export const canonicalStatusUrl = "https://portal-signal-hubspot.netlify.app/api/status";
